<template>
  <div class="mb-2" :class="center ? 'd-flex justify-content-center' : null">
    <template v-if="type === `checkbox`">
      <div v-if="!inline">&nbsp;</div>
      <div class="form-check text-left">
        <input
          :id="identifier"
          ref="input"
          :checked="clean_value"
          :disabled="disabled"
          :name="name"
          class="form-check-input"
          type="checkbox"
          @input="callback(!clean_value)"
        />
        <label :for="identifier" class="form-check-label" style="text-align: start">
          {{ tr(label) }}
        </label>
      </div>
    </template>
    <template v-else-if="type === `layout`">
      <div v-if="!inline">
        <slot name="label">
          <label :for="identifier" class="form-label"
            >{{ label || `&nbsp;` }}<span v-if="required" class="text-red">*</span></label
          >
        </slot>
        <div>
          <slot />
        </div>
      </div>
      <div v-else class="d-flex">
        <slot name="label">
          <label :for="identifier" class="col-md-3"
            >{{ tr(label) }}<span v-if="required" class="text-red">*</span></label
          >
        </slot>
        <div class="pe-2 col-md-9">
          <slot />
        </div>
      </div>
    </template>
    <template v-else-if="inline">
      <div class="d-flex">
        <slot name="label">
          <label :for="identifier" class="col-md-3"
            >{{ tr(label) }}<span v-if="required" class="text-red">*</span></label
          >
        </slot>
        <div class="pe-2 col-md-9">
          <textarea
            v-if="type === `textarea`"
            :id="identifier"
            ref="input"
            :disabled="disabled"
            :name="name"
            :placeholder="tr(placeholder)"
            :required="!!required"
            :rows="rows"
            :value="clean_value"
            class="form-control"
            @input="callback($event)"
          />
          <input
            v-else
            :id="identifier"
            ref="input"
            :disabled="disabled"
            :maxlength="maxlength"
            :name="name"
            :placeholder="placeholder ? tr(placeholder) : type === 'date' ? 'YYYY-MM-DD' : null"
            :required="!!required"
            :step="type === `float` ? 0.01 : 1"
            :type="([`float`, `int`].includes(type) ? `number` : type) || `text`"
            :value="clean_value"
            class="form-control"
            @input="callback($event)"
          />
        </div>
      </div>
    </template>
    <div v-else>
      <slot name="label">
        <label :for="identifier" class="form-label"
          >{{ tr(label) }}<span v-if="required" class="text-red">*</span></label
        >
      </slot>
      <textarea
        v-if="type === `textarea`"
        :id="identifier"
        ref="input"
        :disabled="disabled"
        :name="name"
        :placeholder="tr(placeholder)"
        :required="!!required"
        :rows="rows"
        :value="clean_value"
        class="form-control"
        @input="callback($event)"
      />
      <input
        v-else
        :id="identifier"
        ref="input"
        :disabled="disabled"
        :maxlength="maxlength"
        :name="name"
        :placeholder="placeholder ? tr(placeholder) : type === 'date' ? 'YYYY-MM-DD' : null"
        :required="!!required"
        :step="type === `float` ? 0.01 : 1"
        :type="([`float`, `int`].includes(type) ? `number` : type) || `text`"
        :value="clean_value"
        class="form-control"
        @input="callback($event)"
        @keypress="
          enter_key($event, () => {
            $emit('enter')
          })
        "
      />
    </div>
  </div>
</template>

<script>
  import { enter_key, tr } from '~/assets/scripts/helpers'

  export default {
    name: 'InputControl',
    props: {
      label: { type: String, default: null },
      modelValue: { type: [String, Number, Boolean, Date], default: null },
      type: { type: String, default: 'text' },
      placeholder: { type: String, default: null },
      required: { type: Boolean, default: false },
      inline: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      maxlength: { type: [String, Number], default: null },
      rows: { type: Number, default: null },
      center: { type: Boolean, default: false },
    },
    emits: ['update:modelValue', 'enter'],
    data() {
      return { identifier: null, change_callback: null }
    },
    computed: {
      name() {
        return (this.label || '').replace(/\s/g, '-').toLowerCase()
      },
      clean_value() {
        if (this.type === `date` && this.modelValue && this.modelValue.toString().includes('T')) {
          // coerce ISO date strings to HTML (truncate time component)
          return this.modelValue.split('T')[0]
        }
        if (this.type === `checkbox`) {
          return !!this.modelValue
        }
        return this.modelValue
      },
    },
    beforeMount() {
      this.identifier =
        this.name +
        '-' +
        Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, '')
    },
    methods: {
      enter_key,
      tr,
      focus() {
        this.$refs.input.focus()
      },
      callback(event) {
        let value = event.target ? event.target.value : event
        if (this.type === `date`) {
          try {
            value = event.target.valueAsDate
              ? event.target.valueAsDate.toISOString().split('T')[0]
              : event.target.value
          } catch (e) {
            console.error('Could not read value as date', e)
          }
        }
        this.$emit('update:modelValue', value)
      },
    },
  }
</script>

<style scoped></style>
